import styled from "styled-components";
import { breakpoints, zIndex } from "styles";

export const StyledVideoPlaceholder = styled.div`
  background: ${({ theme }) => theme.colors.white};
  z-index: ${zIndex.videoPlayerControls};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 15px 15px 35px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  pointer-events: none;

  @media ${breakpoints.tablet} {
    padding: 35px 25px;
  }
`;

export const PlaceholderPlayIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const PlaceholderLine = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral["300"]};
  opacity: 0.5;
`;

export const PlaceholderBottom = styled.div`
  position: absolute;
  bottom: 10px;
  height: 10px;
  right: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  @media ${breakpoints.tablet} {
    right: 25px;
    height: 15px;
  }
`;

export const PlaceholderText = styled.div`
  color: ${({ theme }) => theme.colors.brand["500"]};
  font-size: ${({ theme }) => theme.fontSizes.xxs};
  line-height: 1.2;
  height: 100%;

  @media ${breakpoints.tablet} {
    line-height: 1.8;
  }
`;

export const PlaceholderLogo = styled.div`
  width: 45px;
  height: 10px;
  position: relative;

  @media ${breakpoints.tablet} {
    width: 60px;
    height: 15px;
  }
`;
